skrilla.controller('refundDepositModalCtrl', function ($scope, searchService, modalService, cacheService) {
    $scope.deposit = cacheService.getObjectOrElse("depositDetails", modalService.dismissAll);

    $scope.refund = function(){
        modalService.confirm("Are you sure you'd like to refund this deposit?", function(){
            searchService.post("deposits/" + $scope.deposit.id + "/refund", {reason: $scope.message}, "Deposit successfully refunded").then(modalService.dismissAll);
        })
    }
});